import { createSlice } from "@reduxjs/toolkit";
import {
    claimAffiliateOrderThunk,
    fetchAffiliateOrdersThunk,
    submitAffiliateOrderThunk,
    updateAffiliateOrderThunk
} from "./affiliateOrdersThunk";
import { requestPayoutThunk } from "../payouts/payoutsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1
};

export const affiliateOrderSlice = createSlice({
    name: "affiliate-orders",
    initialState,
    reducers: {
        setInitialData: (state, action) => {
            const { items, hasMore, total, totalPages } = action.payload;
            state.items = items;
            state.total = total;
            state.totalPages = totalPages;
            state.hasMore = hasMore;
        },
        removeItem: (state, action) => {
            const id = action.payload;
            state.items = state.items.filter((e) => e.id !== id);
            state.total = state.total - 1;
        },
        resetOrders: (state) => {
            state.items = [];
            state.total = 0;
            state.totalPages = 0;
            state.page = 1;
            state.hasMore = true;
            state.error = null;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffiliateOrdersThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateOrdersThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const orders = data.content;
                state.items = orders;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchAffiliateOrdersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // claim
            .addCase(claimAffiliateOrderThunk.fulfilled, (state, action) => {
                const claimedOrderId = action.payload.id;
                state.items = state.items.filter((e) => Number(e.id) !== Number(claimedOrderId));
                state.total = state.total - 1;
            })
            .addCase(claimAffiliateOrderThunk.rejected, (state, action) => {
                const claimedOrderId = action.meta.arg.orderId;
                state.items = state.items.filter((e) => Number(e.id) !== Number(claimedOrderId));
                state.total = state.total - 1;
            })

            .addCase(submitAffiliateOrderThunk.fulfilled, (state, action) => {
                const submittedOrderId = action.meta.arg.get("orderId");
                state.items = state.items.filter((e) => Number(e.id) !== Number(submittedOrderId));
                state.total = state.total - 1;
            })

            .addCase(requestPayoutThunk.fulfilled, (state, action) => {
                const orderIds = action.meta.arg.orderIds;
                state.items = state.items.filter((e) => !orderIds.includes(e.id));
                state.total = state.total - orderIds.length;
            })

            //update tracking number
            .addCase(updateAffiliateOrderThunk.fulfilled, (state, action) => {
                const { orderId, ...updatedAffiliateOrderData } = action.payload;
                const index = state.items.findIndex((e) => Number(e.id) === Number(orderId));
                if (index !== -1) {
                    state.items[index] = {
                        ...state.items[index],
                        affiliateOrderData: {
                            ...state.items[index].affiliateOrderData,
                            ...updatedAffiliateOrderData
                        }
                    };
                }
            });
    }
});

export const { setInitialData, resetOrders, removeItem, setPage } = affiliateOrderSlice.actions;
export default affiliateOrderSlice.reducer;
